// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#business-credit-screen .gyramais-sub-header {
  min-height: 10.5rem;
}
.proposal-carousel-content .ant-card {
  margin: 0.375rem !important;
}
.ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header {
  padding: 0.75rem 1.5rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.accordion-container {
  box-shadow: none;
  border: 0.063rem solid #C9D3CC;
  border-radius: 0.8rem;
}
.ant-collapse-header {
  font-weight: 600;
}
.gyramais-layout-content .proposal-carousel-content {
  margin-top: -5rem !important;
}
.ant-collapse-header .anticon-right {
  color: #0BB599;
  border-left: 0.063rem solid #C9D3CC;
  padding-left: 1.375rem;
  padding-right: 0.125rem;
  padding-bottom: 0.375rem;
  padding-top: 0.375rem;
}
.ant-collapse-content {
  background: #EDF0EE;
}
.ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header {
  margin-right: 1.375rem;
}
@media (max-width: 768px) {
  .ant-modal-title {
    margin-right: 1.5rem;
  }
}
.gyramais-sub-header .title-container {
  width: 100%;
}
.proposal-card-add .btn-plus-text {
  text-align: center;
  color: #0BB599;
  font-size: 0.813rem;
  font-weight: 500;
  width: 8.75rem;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  margin-top: 0.625rem;
  line-height: 1;
}
.proposal-card-add {
  display: flex;
  width: 5rem;
  box-shadow: none !important;
  border: 0.063rem solid #C9D3CC;
  cursor: pointer;
  padding: 0 !important;
}
.proposal-card-add .ant-card-body {
  padding-left: 10;
  padding: 0;
  width: 100%;
  flex-direction: column;
  align-items: center;
  display: flex;
  align-self: center;
}
.proposal-card-add .ant-card-body img {
  height: 2.25rem;
  width: 2.25rem;
  display: flex;
}
@media (max-width: 768px) {
  .proposal-card-add .ant-card-body img {
    max-width: 4rem;
  }
}
.proposal-card-add .information-title-container h6 b {
  padding: 0px 0px 0px 16px;
  font-weight: 400;
  font-size: 13px;
}
.proposal-card-add .gyramais-information .information-value .value-wrapper {
  padding: 0px 0px 0px 16px;
  font-weight: 400;
  font-size: 15px;
}
@media (max-width: 768px) {
  .proposal-card-add .gyramais-information .information-value .value-wrapper {
    font-size: 0.813rem;
  }
}
@media (max-width: 425px) {
  .proposal-card-add {
    width: 100%;
    height: 11.313rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/BusinessCreditProposalScreen/styles.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AAEA;EACE,2BAAA;AAAF;AAGA;EACE,uBAAA;EACA,iBAAA;EACA,oBAAA;AADF;AAIA;EACE,gBAAA;EACA,8BAAA;EACA,qBAAA;AAFF;AAKA;EACE,gBAAA;AAHF;AAMA;EACE,4BAAA;AAJF;AAOA;EACE,cAAA;EACA,mCAAA;EACA,sBAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA;AALF;AAQA;EACE,mBAAA;AANF;AASA;EACE,sBAAA;AAPF;AAUA;EACE;IACE,oBAAA;EARF;AACF;AAWA;EACE,WAAA;AATF;AAYA;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,cAAA;AAVF;AAaA;EACE,aAAA;EACA,WAAA;EACA,2BAAA;EACA,8BAAA;EACA,eAAA;EACA,qBAAA;AAXF;AAKA;EASI,gBAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAXJ;AAJA;EAkBM,eAAA;EACA,cAAA;EACA,aAAA;AAXN;AAaM;EAAA;IACE,eAAA;EAVN;AACF;AAdA;EA6BI,yBAAA;EACA,gBAAA;EACA,eAAA;AAZJ;AAnBA;EAmCI,yBAAA;EACA,gBAAA;EACA,eAAA;AAbJ;AAiBA;EACE;IACE,mBAAA;EAfF;AACF;AAkBA;EACE;IACE,WAAA;IACA,iBAAA;EAhBF;AACF","sourcesContent":["#business-credit-screen .gyramais-sub-header {\n  min-height: 10.5rem;\n}\n\n.proposal-carousel-content .ant-card {\n  margin: 0.375rem !important;\n}\n\n.ant-collapse-icon-position-right>.ant-collapse-item>.ant-collapse-header {\n  padding: 0.75rem 1.5rem;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.accordion-container {\n  box-shadow: none;\n  border: 0.063rem solid #C9D3CC;\n  border-radius: 0.8rem;\n}\n\n.ant-collapse-header {\n  font-weight: 600;\n}\n\n.gyramais-layout-content .proposal-carousel-content {\n  margin-top: -5rem !important;\n}\n\n.ant-collapse-header .anticon-right {\n  color: #0BB599;\n  border-left: 0.063rem solid #C9D3CC;\n  padding-left: 1.375rem;\n  padding-right: 0.125rem;\n  padding-bottom: 0.375rem;\n  padding-top: 0.375rem;\n}\n\n.ant-collapse-content {\n  background: #EDF0EE;\n}\n\n.ant-collapse-icon-position-right>.ant-collapse-item>.ant-collapse-header {\n  margin-right: 1.375rem;\n}\n\n@media(max-width: @md-screen) {\n  .ant-modal-title {\n    margin-right: 1.5rem;\n  }\n}\n\n.gyramais-sub-header .title-container {\n  width: 100%;\n}\n\n.proposal-card-add .btn-plus-text {\n  text-align: center;\n  color: #0BB599;\n  font-size: 0.813rem;\n  font-weight: 500;\n  width: 8.75rem;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  word-break: break-word;\n  margin-top: 0.625rem;\n  line-height: 1;\n}\n\n.proposal-card-add {\n  display: flex;\n  width: 5rem;\n  box-shadow: none !important;\n  border: .063rem solid #C9D3CC;\n  cursor: pointer;\n  padding: 0 !important;\n\n  .ant-card-body {\n    padding-left: 10;\n    padding: 0;\n    width: 100%;\n    flex-direction: column;\n    align-items: center;\n    display: flex;\n    align-self: center;\n\n    img {\n      height: 2.25rem;\n      width: 2.25rem;\n      display: flex;\n\n      @media(max-width: @md-screen) {\n        max-width: 4rem;\n      }\n    }\n  }\n\n  .information-title-container h6 b {\n    padding: 0px 0px 0px 16px;\n    font-weight: 400;\n    font-size: 13px;\n  }\n\n  .gyramais-information .information-value .value-wrapper {\n    padding: 0px 0px 0px 16px;\n    font-weight: 400;\n    font-size: 15px;\n  }\n}\n\n@media(max-width: 768px) {\n  .proposal-card-add .gyramais-information .information-value .value-wrapper {\n    font-size: 0.813rem;\n  }\n}\n\n@media(max-width: 425px) {\n  .proposal-card-add {\n    width: 100%;\n    height: 11.313rem;\n  }\n}\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
